<template>
    <div style="padding:10px 0px;">
        <van-row>
            <van-col :span="10">
                <div style="height: 56px; width: 56px;">
                    <img style="height: 100%; width: 100%; object-fit: cover;border-radius: 10px"
                        :src="props.img" />
                </div>
            </van-col>
            <van-col :span="12">
                <p style="font-size: 13px; color: #5f6368;font-weight: 600;margin: 0px;">{{ gameName }}</p>
                <p style="font-size: 12px; color: #5f6368;font-weight: 600;margin: 0px;margin-top: 2px">{{ subHeading }}
                </p>
                <div style="display: flex; margin-top: 2px;align-items: center;">
                    <p style="color: #5f6368;font-size: 11px;margin: 0px;margin-right: 2px;">{{ rate }}</p>
                    <van-icon name="star" color="#5f6368" size="10" />

                </div>
            </van-col>
        </van-row>
    </div>
</template>
<script setup lang="ts">
import { defineProps } from 'vue';
const props = defineProps({
    gameName: {
        type: String,
        default: '',
    },
    subHeading: {
        type: String,
        default: '',
    },
    rate: {
        type: Number,
        default: () => 0,
    },
    img: {
        type: String,
        default: 'similarOne',
    }
})
</script>

<style scoped></style>